import { Permissions } from "@evergis/api";
import { LayerInfo } from "../../interfaces/resourceInfo";

const EDIT_PERMISSIONS: Permissions[] = [
  Permissions.Write,
  Permissions.Configure,
  Permissions.ReadWrite,
  Permissions.All,
];

export const isEditable = (permissions?: Permissions): boolean => permissions && EDIT_PERMISSIONS.includes(permissions);

export const isEditableDefinition = (layer: LayerInfo): boolean => layer.layerDefinition?.isEditable || false;

export const isEditableType = (type: string): boolean => type !== "MaterializedView";

export const isReadable = (permissions?: Permissions): boolean =>
  permissions && permissions.split(",").includes(Permissions.Read);
